import moment from "moment";

export default function reservations(
  initialState = {
    reservations: [],
    tables: [],
    search: '',
    startDate: moment().startOf('month').toISOString(),
    endDate: moment().endOf('month').toISOString(),
    activeSort: '',
    sortOrder: '',
    totalCount: 0,
    page: 1
  },
  action
) {
  switch (action.type) {
    case 'SET_RESTAURANT_ADMIN_RESERVATIONS':
      return {
        ...initialState,
        reservations: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_RESERVATIONS_TABLES':
      return {
        ...initialState,
        tables: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_RESERVATIONS_SEARCH':
      return {
        ...initialState,
        search: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_RESERVATIONS_START_DATE':
      return {
        ...initialState,
        startDate: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_RESERVATIONS_END_DATE':
      return {
        ...initialState,
        endDate: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_RESERVATIONS_ACTIVE_SORT':
      return {
        ...initialState,
        activeSort: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_RESERVATIONS_SORT_ORDER':
      return {
        ...initialState,
        sortOrder: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_RESERVATIONS_TOTAL_COUNT':
      return {
        ...initialState,
        totalCount: action.payload,
      };

    case 'SET_RESTAURANT_ADMIN_RESERVATIONS_PAGE':
      return {
        ...initialState,
        page: action.payload,
      };


    case 'RESTAURANT_ADMIN_RESERVATIONS_RESET':
      return {
        ...initialState,
        reservations: [],
        tables: [],
        search: '',
        startDate: moment().startOf('month').toISOString(),
        endDate: moment().endOf('month').toISOString(),
        activeSort: '',
        sortOrder: '',
        totalCount: 0,
        page: 1
      };

    default:
      return initialState;
  }
}
